import { lazy } from 'react';

import CustomLazyLoader from 'routes/CustomLazyLoader';

export const Clients = lazy(() => CustomLazyLoader(
  () => import('modules/clients/containers/Clients'),
  'Clients'
));

export default Clients;
